// Central source for the application / brand name shown across the UI.
//
// Defined directly here (single place to edit). Every render site and the
// browser-tab title go through getAppName(), so changing this one string
// rebrands the app name everywhere.
export const getAppName = () => "rupyyBOX Payment";
